import isReadOnlyProperty from './isReadOnlyProperty';
import toPropertyName from './toPropertyName';
import isComputedProperty from './isComputedProperty';
import {memoize} from '@servicenow/ui-internal';

const shouldSetMemoized = memoize(
	function shouldSetAttribute(tagName, name, defs) {
		const readOnly = isReadOnlyProperty(toPropertyName(name), defs);
		const computedProperty = isComputedProperty(toPropertyName(name), defs);

		return !readOnly && !computedProperty;
	},
	{profileName: 'shouldSetAttribute'}
);

export default function shouldSetAttribute(tagName, isReflecting, name, defs = {}) {
	return isReflecting || shouldSetMemoized(tagName, name, defs);
}
